<template>
  <stacked-bar
    :chart-data="chartData"
    :loading="loading"
    stacked-type="percent"
    chart-v-ax-format="percent"
    :bus="bus"
    v-on:bar-selected="triggerBarSelect"
  ></stacked-bar>
</template>

<script>
import StackedBar from "../../../charts/StackedBar";
import Vue from "vue";

export default {
  name: "EscalationPercentage",
  data() {
    return {
      loading: false
    }
  },
  props: ['date-range', 'updateData', 'viewData', 'bus'],
  components: {StackedBar},
  computed: {
    chartData: function() {
      return this.viewData
    }
  },
  methods: {
    triggerBarSelect(event) {
      this.$emit('escalation-bar-selected', event);
    }
  }
}
</script>

<style scoped>

</style>
